export default __webpack_public_path__ + "static/media/sts.d11dee4f.png";